import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
import { ajax } from '@blade/common';
import { EType } from '@blade/common/interfaces/user-group';
let Staff = class Staff extends VuexModule {
    async getStaffs(data) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/portrait-management/api/v1/pass/portraitLib/query',
                data: data,
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async createStaff(data) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/portrait-management/api/v1/pass/portraitLib/create',
                data: data,
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getStaffById(id) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: `/api/portrait-management/api/v1/pass/portraitLib/${id}`,
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async updateStaff(data) {
        try {
            const res = await ajax.request({
                method: 'PUT',
                url: `/api/portrait-management/api/v1/pass/portraitLib/${data.id}`,
                data: { name: data.name, remark: data.remark, userIds: data.userIds },
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async deleteStaff(id) {
        try {
            const { data } = await ajax.request({
                method: 'DELETE',
                url: `/api/portrait-management/api/v1/pass/portraitLib/${id}`,
            });
            return data;
        }
        catch (e) {
            throw e;
        }
    }
    async getPassportraits(data) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: `/api/portrait-management/api/v1/pass/portrait/${data.personGroup === EType.GUEST ? 'visitor' : 'white'}/query`,
                data: { ...data },
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async createPasssstaff(data) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: `/api/portrait-management/api/v1/pass/portrait/addPerson`,
                data: { ...data },
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getPortraitsGroup({ data, mode }) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: `/api/portrait-management/api/v1/pass/portraitLib/query/group`,
                params: { userGroup: data, onlyUserCreate: mode === 'CREATE' },
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getPortraitById(id) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: `/api/portrait-management/api/v1/pass/portrait/${id}`,
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async updatePortrait(data) {
        try {
            const res = await ajax.request({
                method: 'PUT',
                url: `/api/portrait-management/api/v1/pass/portrait/${data.id}`,
                data: { ...data.paramStaff },
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async deletePortrait(id) {
        try {
            await ajax.request({
                method: 'DELETE',
                url: `/api/portrait-management/api/v1/pass/portrait/${id}`,
            });
        }
        catch (e) {
            throw e;
        }
    }
    async exportPortraits(data) {
        console.log('params:', data);
        try {
            const res = await ajax.request({
                method: 'POST',
                url: `/api/portrait-management/api/v1/feature/batch/export`,
                data: { ...data },
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getTags(data) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: `/api/user-management/api/v1/ums/org/orgUser/tree/`,
                params: { name: data },
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async deleteAll(data) {
        try {
            const res = await ajax.request({
                method: 'DELETE',
                url: `/api/access-management/api/v1/pass/task/record`,
                data: data
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    updateAccount(payload) { }
};
__decorate([
    Action({ rawError: true })
], Staff.prototype, "getStaffs", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "createStaff", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "getStaffById", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "updateStaff", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "deleteStaff", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "getPassportraits", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "createPasssstaff", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "getPortraitsGroup", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "getPortraitById", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "updatePortrait", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "deletePortrait", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "exportPortraits", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "getTags", null);
__decorate([
    Action({ rawError: true })
], Staff.prototype, "deleteAll", null);
__decorate([
    Mutation
], Staff.prototype, "updateAccount", null);
Staff = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/staff' })
], Staff);
export const StaffModule = getModule(Staff);
